export enum USER_ROUTES_NAMES {
  USER_INDEX = "users-index",
}
